import * as apiRoutes from '../../apiRoutes';
import { actionTypes } from "../../actionTypes";
import { APIUrl } from "../../constants";
import * as api from '../../tools/apiMiddleware';
import { toDate } from '../../tools/toolkit';

export const PublicationData = { id: 0, identifier: '', platform: { id: 0, name: '' } };
const initialState = { data: PublicationData, isLoading: true, canReturnBack: false };

export const actionCreators = {
    getPublication: (programmeId, publicationId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.Publication + `/${programmeId}/${publicationId}`;
        await api.getRequest(dispatch, url, actionTypes.GET_PUBLICATION, actionTypes.GET_PUBLICATION_SUCCESS, actionTypes.GET_PUBLICATION_FAIL);

    },
    createPublication: (programmeId, data) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.Publication + `/${programmeId}`;
        await api.createRequest(dispatch, url, data, actionTypes.ADD_PUBLICATION, actionTypes.ADD_PUBLICATION_SUCCESS, actionTypes.ADD_PUBLICATION_FAIL);


        let url2 = APIUrl + apiRoutes.Publication + '/' + programmeId;
        await api.getRequest(dispatch, url2, actionTypes.GET_PUBLICATION_LOG, actionTypes.GET_PUBLICATION_LOG_SUCCESS, actionTypes.GET_PUBLICATION_LOG_FAIL);
    },
    newPublication: (programmeId) => async (dispatch) => {
        const url = APIUrl + apiRoutes.Publication + `/${programmeId}/0`;
        await api.getRequest(dispatch, url, actionTypes.NEW_PUBLICATION, actionTypes.NEW_PUBLICATION_SUCCESS, actionTypes.NEW_PUBLICATION_FAIL);
    },
    clearErrorMessage: () => (dispatch, getState) => {

        dispatch({ type: actionTypes.PUBLICATION_CLEAR_ERROR });

    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case actionTypes.GET_PUBLICATION:
            return {
                ...state,
                data: state.data,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.GET_PUBLICATION_SUCCESS:
            if (!action.data.platform) {
                action.data.platform = { id: 0 };
            }
            return {
                ...state,
                data: action.data,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.GET_PUBLICATION_FAIL:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data
            };
        case actionTypes.NEW_PUBLICATION:
            return {
                ...state,
                data: state.data,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.NEW_PUBLICATION_SUCCESS:
            if (!action.data.platform) {
                action.data.platform = { id: 0 };
            }
            return {
                ...state,
                data: action.data,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.NEW_PUBLICATION_FAIL:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data
            };
        case actionTypes.PUBLICATION_CLEAR_ERROR:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: false
            };
        case actionTypes.ADD_PUBLICATION:
            return {
                ...state,
                data: state.data,
                isLoading: true
            };
        case actionTypes.ADD_PUBLICATION_SUCCESS:
            return {
                ...state,
                data: PublicationData,
                isLoading: false
            };
        case actionTypes.ADD_PUBLICATION_FAIL:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data
            };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/NonLinear/PublicationStore.js